import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { actions } from '../actions';
import { getControlId, getDonorRollErrors, getDonorRollInstanceSettings, getApiPollingTimeInterval } from '../selectors';
import { DonorRollDataApi } from '../requests';
import { actions as donorRollActions } from 'donorRoll';
import { network } from '@imodules/helix';

const { populateDonorRollData } = donorRollActions;

export const initiateDonorRollPolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const timeInterval: number = getApiPollingTimeInterval(state) || 0;

        while (getDonorRollErrors(state) < 5) {
            const request = dispatch(pollDonorRoll());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollDonorRoll = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const settings = getDonorRollInstanceSettings(state);
        const controlId = getControlId(state);

        if (settings) {
            try {
                dispatch(await makeDonorRollRequest([controlId, 300]));
                dispatch(actions.apiCallSuccess());
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
        }
    };
};

export const makeDonorRollRequest = (params: number[]): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch) => {
        const [controlId, recordCount] = params;
        try {
            const request = DonorRollDataApi.createGetRequest(controlId, recordCount);
            const result: any = await network.call(request);

            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(populateDonorRollData(result.response.content));
                dispatch(actions.apiCallSuccess());
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};
export const watchGetDonorRollData = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateDonorRollPolling());
    };
};